import { PrismicRichText } from '@prismicio/react';
import { SectionWrapper, TitleComponent } from 'remote-com-shared/components/ClientLogos';
import {
  ClientLogosSlider,
  RightBG,
} from 'remote-com-shared/components/ClientLogos/ClientLogosSlider';
import { fieldHasContent } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Title, Description } from './PartnersSlice';

import { fromDesktopBreakpoint } from '@/src/domains/shared/breakpoints';

const Wrapper = styled.section`
  ${fluidProp('padding-bottom', '50px', '75px')};
  ${fluidProp('padding-top', '90px', '125px')};
  text-align: center;
  font-family: var(--typography-fontBossa);
  color: var(--colors-blank);
  z-index: 0;
  position: relative;

  ${SectionWrapper} {
    padding: 0;
    background: transparent;

    ${TitleComponent} {
      margin-bottom: 0;
    }
  }

  ${RightBG} {
    display: none;
  }

  ${({ $tone }) => {
    switch ($tone) {
      case 'orange':
        return css`
          background-color: var(--colors-darkBlue);
        `;
      case 'red':
      case 'green':
        return css`
          background-color: #000000;
        `;
      default:
        return css`
          background-color: #5700ff;
          background-image: none;
        `;
    }
  }}

  ${fromDesktopBreakpoint(css`
    clip-path: ellipse(100% 100% at 50% 0%);
    ${fluidProp('padding-bottom', '100px', '170px')}
  `)}
`;

export function LogosSlice({ slice }) {
  const { primary, fields } = slice;
  const { title, description } = primary;
  const { context } = slice;
  const { tone } = context;

  return (
    <Wrapper $tone={tone}>
      {fieldHasContent(title) && (
        <Title>
          <PrismicRichText field={title} />
        </Title>
      )}
      {fieldHasContent(description) && (
        <Description>
          <PrismicRichText field={description} />
        </Description>
      )}
      <ClientLogosSlider logos={fields} swiperProps={{ spaceBetween: 150, loopedSlides: 5 }} />
    </Wrapper>
  );
}
